// Конфигурация колонок канбан-доски
// status < 100 — колонки заявок (по PayoutRequest.status)
// status >= 100 — виртуальные реестровые колонки (фильтрация по registry.status)
var STATUS_COLUMNS = [
    { status: 0,   label: "Создана",           color: "#546e7a", bg: "#eceff1" },
    { status: 1,   label: "Антифрод",          color: "#f57f17", bg: "#fff9c4" },
    { status: 7,   label: "Ожидает выплаты",  color: "#0277bd", bg: "#e1f5fe" },
    { status: 100, label: "Реестр создан",     color: "#7b1fa2", bg: "#f3e5f5", isRegistry: true, registryStatus: [0] },
    { status: 101, label: "В работе",          color: "#e65100", bg: "#fff3e0", isRegistry: true, registryStatus: [1] },
    { status: 102, label: "Обработан",         color: "#2e7d32", bg: "#e8f5e9", isRegistry: true, registryStatus: [2, 3] },
    { status: 5,   label: "Успех",             color: "#2e7d32", bg: "#e8f5e9" },
    { status: 2,   label: "Отклонена",         color: "#c62828", bg: "#ffebee" },
    { status: 6,   label: "Ошибка",            color: "#ad1457", bg: "#fce4ec" },
];

// Разрешённые переходы при drag & drop: fromStatus → [допустимые toStatus]
var ALLOWED_TRANSITIONS = {
    0: [7, 2],     // Создана → Ожидает (через антифрод) или Отклонена
    3: [7],        // Реестр → Ожидает (вернуть из реестра)
    6: [7, 2],     // Ошибка → Ожидает или Отклонена
    7: [2],        // Ожидает → Отклонена
};

function isTransitionAllowed(fromStatus, toStatus) {
    var allowed = ALLOWED_TRANSITIONS[fromStatus];
    if (!allowed) return false;
    return allowed.indexOf(toStatus) >= 0;
}

function formatAmount(amount) {
    if (amount === null || amount === undefined) return "-";
    var value = Number(amount);
    return value.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20BD";
}

function formatDate(dateStr) {
    if (!dateStr) return "";
    var d = new Date(dateStr);
    return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}

// Проверить, попадает ли реестр в колонку по статусу
function matchRegistryStatus(registryStatus, allowedStatuses) {
    return allowedStatuses.indexOf(registryStatus) >= 0;
}

// Статусы заявок, у которых есть своя колонка (без виртуальных реестровых)
function boardRequestStatuses() {
    return STATUS_COLUMNS.filter(function (col) {
        return !col.isRegistry;
    }).map(function (col) {
        return col.status;
    });
}

// Клик по бейджу статуса -> какие колонки показать.
// Статус 3 ("В реестре") своей колонки не имеет: такие заявки лежат в реестрах,
// поэтому показываем все три реестровые колонки.
function columnsForQuickStatus(status) {
    if (status === null || status === undefined) return null;
    if (Number(status) === 3) return [100, 101, 102];
    return [Number(status)];
}

export {
    STATUS_COLUMNS,
    ALLOWED_TRANSITIONS,
    isTransitionAllowed,
    formatAmount,
    formatDate,
    matchRegistryStatus,
    boardRequestStatuses,
    columnsForQuickStatus,
};
export default {
    STATUS_COLUMNS,
    ALLOWED_TRANSITIONS,
    isTransitionAllowed,
    formatAmount,
    formatDate,
    matchRegistryStatus,
    boardRequestStatuses,
    columnsForQuickStatus,
};



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/CrmPayoutBoard/CrmPayoutBoardUtils.js